export const getList = (state) => state.list
export const getAll = (state) => state.all
export const getCompany = (state) => state.company
export const getBusiness = (state) => state.business
export const getSize = (state) => state.size
export const getForm = (state) => state.form
